<template>
  <div
    class="category_wrapper pt-sm pb-sm"
    :class="{ category_active: isActive }"
    @click="toggleCategory"
  >
    <div>
      <h2>{{ category }}</h2>
      <div class="arr__wrapper">
        <img
          class="arr__down"
          :src="require('@/assets/arrow-down-circle.svg')"
        />
      </div>
    </div>
    <p>
      {{ description }}
    </p>
  </div>
</template>

<script setup>
import { ref } from "vue";

const props = defineProps({
  category: String,
  description: String,
});

const isActive = ref(false);

const toggleCategory = () => {
  isActive.value = !isActive.value;
};
</script>

<style scoped lang="scss">
.category_wrapper {
  width: 100%;
  display: flex;
  justify-content: center;
  flex-direction: column;
  border-bottom: 2px solid $btn--border;
  cursor: pointer;
  position: relative;

  div {
    display: flex;
    justify-content: space-between;
    align-items: center;

    h2 {
      font-weight: 520;
      cursor: pointer;
      padding-top: map-get($spaces, "xs");
      padding-bottom: map-get($spaces, "xs");
      transition: all 0.2s ease-in-out;
      &:hover {
        color: $brand--col;
        transition: all 0.2s ease-in-out;
      }
    }

    img {
      width: 2em;
      transition: transform 0.3s ease-in-out;
    }
  }

  p {
    height: 0;
    overflow: hidden;
    opacity: 0;
    transition: height 0.3s ease-in-out, opacity 0.3s ease-in-out;
  }

  &.category_active {
    p {
      height: auto;
      opacity: 1;
      padding-top: map-get($spaces, "xs");
      padding-bottom: map-get($spaces, "xs");
    }
    h2 {
      color: $brand--col;
    }
    .arr__down {
      transform: rotate(180deg);
    }
  }
}
</style>
